export default "__VITE_ASSET__Duvd$_NQ__"